const isNode = require('./isNode');

const environment = isNode() ? process.env.NODE_CONFIG_ENV || process.env.NODE_ENV : window.__ENV__;
const rComConfig = require('../ajio-config/index.js').init(environment);

module.exports = {
  get(name) {
    if (rComConfig && rComConfig.endpoints && rComConfig.endpoints[name]) {
      return rComConfig.endpoints[name].href;
    }
  },
  getProperties(name) {
    if (rComConfig && rComConfig.properties && rComConfig.properties[name]) {
      return rComConfig.properties[name];
    }
  }
};
